export const convertJavaToJsRegex = (javaRegex: string): RegExp | null => {
  try {
    let pattern = javaRegex;
    let flags = '';

    // 1. Extract and remove inline flags like (?i), (?m), (?s)
    // We look for (?...) at the very start of the string
    const inlineFlagMap: Record<string, string> = {
      i: 'i', // Case-insensitive
      m: 'm', // Multiline
      s: 's', // Dotall
    };

    const inlineFlagRegex = /^\(\?([ims]+)\)/;
    const match = pattern.match(inlineFlagRegex);

    if (match) {
      const foundFlags = match[1];
      for (const char of foundFlags) {
        const jsFlag = inlineFlagMap[char];
        if (jsFlag && !flags.includes(jsFlag)) {
          flags += jsFlag;
        }
      }
      // Remove the (?i) part from the pattern
      pattern = pattern.replace(inlineFlagRegex, '');
    }

    // 2. Normalize backslashes (\\s -> \s)
    pattern = pattern.replace(/\\\\/g, '\\');

    // 3. Remove Possessive Quantifiers (.*+ -> .*)
    pattern = pattern.replace(/(\*\+|\+\+|\?\+|\}\+)/g, (m) => m.charAt(0));

    // 4. Convert Java Boundaries (\A -> ^, \z -> $)
    pattern = pattern.replace(/\\A/g, '^').replace(/\\z/g, '$');

    return new RegExp(pattern, flags);
  } catch (error) {
    if (error instanceof Error) {
      console.error(`Regex Conversion Error: ${error.message}`);
    }
    return null;
  }
};
